var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',{staticClass:"scroller"},[_c('div',{staticClass:"content-img",staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"image-slide",attrs:{"src":_vm.imageUrl+'/slide.png',"alt":"slide"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }